if (!window.customElements.get("component-pair-slider")) {

class PairSlider extends HTMLElement {

    constructor() {
      super();

      this.selectors = {
        swiper: "swiper-container",
        prevEl: ".custom-prev-button",
        nextEl: ".custom-next-button",
      }

      this.slider = this.querySelector(this.selectors.swiper);
      this.buttonPrev = this.querySelector(this.selectors.prevEl);
      this.buttonNext = this.querySelector(this.selectors.nextEl);
      this.isInitialized = false;
    }

    connectedCallback() {
      if (this.isInitialized) return;
      if (!this.slider) return;
      this.initSlider();
      this.isInitialized = true;
    }

    initSlider() {
      const swiperParams = {
        slidesPerView: 1.2,
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
          990: {
            slidesPerView: 4,
          },
        },
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev,
        },
        on: {
          init() {
          }
        },
      };

      Object.assign(this.slider, swiperParams);

      this.slider.initialize();

    }
  }

  customElements.define('component-pair-slider', PairSlider);


}
